import React, { useEffect } from 'react';
import Slider from "react-slick";
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
let sliderData=[
  {
    img: `${ImageUrl}theme/macau/sl1.jpg`
  },
  {
    img: `${ImageUrl}theme/macau/sl2.jpg`
  },
  {
    img: `${ImageUrl}theme/macau/sl3.jpg`
  }
]
const MacauSlider = () => {
  var settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    accessibility: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    }
  };
  return (
    <>


      <Slider {...settings} className='overflow-hidden bannerSliderHome'>
      {sliderData?.map((val, index) =>
        <div key={index}>
          <LazyLoadImage src={val?.img} alt="slider" className='img-fluid' />
        </div>
      )}
        </Slider>
    </>
  )
}

export default MacauSlider;